import authInstance from 'config/axios.config';

export const jobServices = {
  // Job Management
  getJobs: async (filters) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== 'all' && value !== '') {
        params.append(key, String(value));
      }
    });

    const res = await authInstance.get(`/admin/jobs?${params}`);
    return res.data;
  },

  getJobById: async (jobId) => {
    const res = await authInstance.get(`/admin/jobs/${jobId}`);
    return res.data;
  },

  updateJob: async ({ jobId, data }) => {
    const res = await authInstance.put(`/admin/jobs/${jobId}`, data);
    return res.data;
  },

  deleteJob: async (jobId) => {
    const res = await authInstance.delete(`/admin/jobs/${jobId}`);
    return res.data;
  },

  // Application Management
  getAllApplications: async (filters) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== 'all' && value !== '') {
        params.append(key, String(value));
      }
    });

    const res = await authInstance.get(`/admin/jobs/applications/all?${params}`);
    return res.data;
  },

  getJobApplicants: async ({ jobId, ...filters }) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== 'all' && value !== '') {
        params.append(key, String(value));
      }
    });

    const res = await authInstance.get(`/admin/jobs/${jobId}/applicants?${params}`);
    return res.data;
  },

  // Stats
  getJobStats: async () => {
    const res = await authInstance.get('/admin/jobs/stats');
    return res.data;
  },

  exportJobs: async ({
  search,
  status,
  visibility,
  sellerId,
  city,
  sortBy,
  order,
}) => {
  const params =
    new URLSearchParams({
      search:
        search || '',

      status:
        status === 'all'
          ? ''
          : status || '',

      visibility:
        visibility === 'all'
          ? ''
          : visibility || '',

      sellerId:
        sellerId || '',

      city:
        city || '',

      sortBy:
        sortBy || 'createdAt',

      order:
        order || 'desc',
    });

  for (const [key, value] of [
    ...params.entries(),
  ]) {
    if (!value) {
      params.delete(key);
    }
  }

  return authInstance.get(
    `/admin/jobs/export?${params.toString()}`,
    {
      responseType: 'blob',
    }
  );
},

exportApplicants: async (jobId, params) => {
  return authInstance.get(`/admin/jobs/${jobId}/applicants/export`, {
    params,
    responseType: 'blob',
  });
},
};
